import { render, staticRenderFns } from "./exhibition-join-info.vue?vue&type=template&id=583b2244&scoped=true&"
import script from "./exhibition-join-info.vue?vue&type=script&lang=js&"
export * from "./exhibition-join-info.vue?vue&type=script&lang=js&"
import style0 from "./exhibition-join-info.vue?vue&type=style&index=0&id=583b2244&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "583b2244",
  null
  
)

export default component.exports